module.exports = ":host {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/report/components/report-dashboard.component.scss
// module id = ./src/app/report/components/report-dashboard.component.scss
// module chunks = main